var React = require('react');

function ArrowDown (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M8 12.667a.668.668 0 0 1-.491-.216l-7.334-8a.667.667 0 0 1 .983-.902L8 11.013l6.842-7.464a.667.667 0 0 1 .983.902l-7.334 8a.668.668 0 0 1-.49.216"}));
}

ArrowDown.displayName = "ArrowDown";

ArrowDown.defaultProps = {"viewBox":"-2 -1 20 20"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-down.svg
// module id = 1245
// module chunks = 0